import React from "react";
import { PALETTE } from "../../common/ThemeConstants";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { InputGroup } from "react-bootstrap";

export default function CardExerciseCompleted({
  exercise,
  onWeightChanged,
  height = 80,
  weightValue = "",
}) {
  return (
    <div className="my-2 rounded-md shadow-sm">
      <Row style={{ width: "100%" }} className="g-0 align-items-center m-auto px-1">
        <Col xs={3} className="align-self-center py-1 px-0">
          <Card.Img
            style={{
              objectFit: "cover",
              height: height,
              width: height,
              maxWidth: "100%",
              borderRadius: "20px",
            }}
            src={exercise.cover}
            alt={exercise.name}
          />
        </Col>
        <Col xs={9} className="px-1 text-start">
          <Row className="g-0 align-items-center">
            <Col sm>
              <p className="mb-0 cardTitle">{exercise.name}</p>
            </Col>
            <Col sm>
              <InputGroup>
                <Form.Control
                  style={{
                    borderTopLeftRadius: "10px",
                    borderBottomLeftRadius: "10px",
                  }}
                  placeholder="Weight"
                  type="number"
                  value={weightValue}
                  onChange={(event) => {
                    onWeightChanged(exercise.id, event.target.value);
                  }}
                  aria-label="Recipient's username"
                  aria-describedby="weight-addon"
                />
                <InputGroup.Text
                  id="weight-addon"
                  style={{
                    backgroundColor: PALETTE.LIGHTGRAY,
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    color: PALETTE.GRAY,
                  }}
                >
                  KG
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
